// extracted by mini-css-extract-plugin
export var required = "_d1-0";